import IconLink from '@src/assets/icons/icon-link.png';
import IconUpload from '@src/assets/icons/icon-upload.png';

// Import icon for file upload
import IconFileWord from '@src/assets/icons/icon-file-word.png';
import IconFileText from '@src/assets/icons/icon-file-text.png';
import IconFileImage from '@src/assets/icons/icon-file-image.png';

// Import icon for upload type for project feature
import InputByTxtDocx from '@src/assets/images/input-by-txt-docx.png';
import InputByWeblink from '@src/assets/images/input-by-weblink.png';
import InputWithText from '@src/assets/images/input-with-text.png';
import InputByPdf from '@src/assets/images/input-by-pdf.png';

// Import icon for web sample crawler
import IconCafeF from '@src/assets/icons/icon-cafe-f.png';
import IconExpress from '@src/assets/icons/icon-express.png';
import IconDanTri from '@src/assets/icons/icon-dan-tri.png';
import IconKenh14 from '@src/assets/icons/icon-kenh-14.png';
import IconBaoMoi from '@src/assets/icons/icon-bao-moi.png';
import IconZing from '@src/assets/icons/icon-zing.png';
import { FEATURE } from './package';

// Maximum file size is 15MB
export const MEGA_BYTE = 15 * 1024 * 1024;

export const TYPE_UPLOAD = {
  LINK: 'link',
  FILE: 'file',
};

export const OPTION_UPLOAD_FILE = [
  {
    icon: IconFileWord,
    type: ['docx'],
    isActive: true,
    alt: 'file-word',
    feature: FEATURE.INPUT_DOC,
  },
  {
    icon: IconFileText,
    type: ['txt'],
    isActive: true,
    alt: 'file-text',
    feature: FEATURE.INPUT_TXT,
  },
  {
    icon: IconFileImage,
    type: ['jpg', 'png'],
    isActive: false,
    alt: 'file-image',
    feature: FEATURE.INPUT_IMAGE,
  },
];

export const OPTIONS_UPLOAD = [
  {
    icon: IconLink,
    label: 'webLink',
    type: TYPE_UPLOAD.LINK,
    isActive: true,
    formatFile: null,
    feature: FEATURE.INPUT_URL,
    featureDesc: 'inputUrlDesc',
  },
  {
    icon: IconUpload,
    label: 'uploadDocuments',
    type: TYPE_UPLOAD.FILE,
    isActive: false,
    formatFile: null,
  },
  {
    icon: IconFileWord,
    label: 'wordFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: '.docx',
    feature: FEATURE.INPUT_DOC,
    featureDesc: 'inputDocDesc',
  },
  {
    icon: IconFileText,
    label: 'textFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: '.txt',
    feature: FEATURE.INPUT_TXT,
    featureDesc: 'inputTxtDesc',
  },
  {
    icon: IconFileImage,
    label: 'imageFile',
    type: TYPE_UPLOAD.FILE,
    isActive: false,
    formatFile: '.jpg, .png',
    feature: FEATURE.INPUT_IMAGE,
    featureDesc: 'inputImageDesc',
  },
];

export const LIST_ICON_WEB_SAMPLE = [
  {
    icon: IconCafeF,
    alt: 'CafeF',
  },
  {
    icon: IconExpress,
    alt: 'Express',
  },
  {
    icon: IconDanTri,
    alt: 'Dan Tri',
  },
  {
    icon: IconKenh14,
    alt: 'Kenh14',
  },
  {
    icon: IconBaoMoi,
    alt: 'Bao Moi',
  },
  {
    icon: IconZing,
    alt: 'Zing',
  },
];

// - Vietnamese accented characters
// - Digits (0-9)
// - Whitespace (\s)
// - Punctuation: period (.), comma (,), and other special characters like !, ?, +, ;, ()
export const ALOWED_CHARACTERS_PDF_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^[aAàÀảẢãÃáÁạẠăĂằẰẳẲẵẴắẮặẶâÂầẦẩẨẫẪấẤậẬbBcCdDđĐeEèÈẻẺẽẼéÉẹẸêÊềỀểỂễỄếẾệỆfFgGhHiIìÌỉỈĩĨíÍịỊjJkKlLmMnNoOòÒỏỎõÕóÓọỌôÔồỒổỔỗỖốỐộỘơƠờỜởỞỡỠớỚợỢpPqQrRsStTuUùÙủỦũŨúÚụỤưƯừỪửỬữỮứỨựỰvVwWxXyYỳỲỷỶỹỸýÝỵỴzZ0-9\s.,!?'"-+;:()\[\]{}%&@#$^*+=<>\\/]+$/;

export const PROJECT_OPTIONS_INPUT = [
  {
    icon: InputWithText,
    label: 'inputWithText',
    type: null,
    isActive: true,
    formatFile: null,
  },
  {
    icon: InputByTxtDocx,
    label: 'inputTxtDocxFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: ['.docx', '.txt'],
  },
  {
    icon: InputByPdf,
    label: 'inputPdfFile',
    type: TYPE_UPLOAD.FILE,
    isActive: true,
    formatFile: ['.pdf'],
  },
  {
    icon: InputByWeblink,
    label: 'inputWebLink',
    type: TYPE_UPLOAD.LINK,
    isActive: true,
    formatFile: null,
  },
];
